var _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFunnelOverview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Funnel overview icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 49.98 42.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Dashboard view icon"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 289"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 288"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 232",
    d: "M47.98 40.89h1v1.6h-1z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 290"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 461",
    d: "M0 0v42.49h47.98v-1.6H1.59V10.25h46.39v30.64h1v1.6h1V0zm47.98 8.25H1.59V2h46.39z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 233",
    d: "M47.98 40.89h1v1.6h-1z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 291"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 462",
    d: "M36.31 14.17a8.735 8.735 0 108.74 8.73 8.747 8.747 0 00-8.74-8.73zm-6.74 8.73a6.624 6.624 0 01.4-2.28l4.86 2.62-3.23 4.47a6.679 6.679 0 01-2.03-4.81zm6.74 6.74a6.6 6.6 0 01-3.09-.76l4.57-6.32-6.86-3.7a6.735 6.735 0 115.38 10.78z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 292"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 234",
    d: "M28.57 35.51h15.48v2H28.57z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2974"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2638",
    d: "M12.256 26.327h7.005l-1.386 2.751h-4.234z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2639",
    d: "M22.247 20.413l-2.2 4.361h-8.574l-2.2-4.361z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2640",
    d: "M25.518 13.927l-2.486 4.927H8.487l-2.486-4.927z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 979",
    d: "M13.655 34.425h4.122V36.7h-4.122z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 980",
    d: "M13.655 30.381h4.122v3.039h-4.122z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnelOverview);
export default __webpack_public_path__ + "static/media/FunnelOverview.6565c8b1.svg";
export { ForwardRef as ReactComponent };